import { PathAPI } from '../../../api/schematicmap/PathAPI';

export class PathsCommand {
    get(edition, lineIds, successCallback, errorCallback) {
        const apiResult = PathAPI.get(edition, lineIds);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getShapes(edition, pathIds, successCallback, errorCallback) {
        const apiResult = PathAPI.getShapes(edition, pathIds);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
